import { render, staticRenderFns } from "./AdminGridItem.vue?vue&type=template&id=071e93f8&"
import script from "./AdminGridItem.vue?vue&type=script&lang=ts&"
export * from "./AdminGridItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports